import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { proApi, eur, errMsg } from "@/lib/proApi";
import { usePro } from "@/context/ProContext";

export const ProQuickReorder = ({ className = "" }) => {
  const { approved, user, loadCart } = usePro();
  const nav = useNavigate();
  const [last, setLast] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!approved) return setLast(null);
    proApi.get("/pro/orders").then(({ data }) => setLast(data[0] || null)).catch(() => {});
  }, [approved]);

  if (!last) return null;

  const go = async () => {
    setBusy(true);
    try {
      const { data } = await proApi.post(`/pro/orders/${last.order_number}/reorder?replace=true`);
      await loadCart(user);
      toast.success(`Panier prêt : ${data.added} référence(s)${data.skipped ? `, ${data.skipped} indisponible(s)` : ""} aux prix du jour`);
      nav("/espace-pro/panier");
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  const refs = last.lines.length;
  return (
    <div data-testid="pro-quick-reorder" className={`flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-2xl border-2 border-[var(--oz-gold)] bg-[var(--oz-bg-2,#faf6f0)] p-5 ${className}`}>
      <div>
        <p className="font-semibold text-[var(--oz-text)]">Commande express</p>
        <p data-testid="pro-quick-reorder-info" className="text-sm text-[var(--oz-muted)]">
          Dernière commande {last.order_number} du {new Date(last.created_at).toLocaleDateString("fr-FR")} — {refs} référence{refs > 1 ? "s" : ""}, {eur(last.total_ht_cents)} HT
        </p>
      </div>
      <button onClick={go} disabled={busy} data-testid="pro-quick-reorder-button"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[var(--oz-dark)] text-white font-semibold text-sm px-6 py-3.5 min-h-[48px] hover:bg-black transition-colors disabled:opacity-60 whitespace-nowrap">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RotateCcw className="w-4 h-4 text-[var(--oz-gold)]" />}
        Recommander ma dernière commande
      </button>
    </div>
  );
};
